import { RemoteGroupsCount } from 'data/usecases';
import { GroupsCountUseCaseInterface } from 'domain/usecases';
import { makeApiUrlAdminEntity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGroupsCount = (): GroupsCountUseCaseInterface =>
  new RemoteGroupsCount(makeApiUrlAdminEntity(), makeAxiosHttpClient());
